module["exports"] = [
  "(##) ####-####",
  "+55 (##) ####-####",
  "(##) #####-####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_BR/phone_number/formats.js
// module id = 1876
// module chunks = 1